<template>
    <div class="w-[295px] bg-white pt-[35px] px-5 flex flex-col space-y-1.5">
        <a :href="route('index')" class="inline-flex space-x-[25px] items-center text-gray-20 rounded-md" :class="{
            'shadow-normal': route().current('index')
        }">
            <div class="p-3 rounded-md" :class="{'bg-primary text-secondary': route().current('index')}">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"></path></svg>
            </div>
            <div class="text-sm font-semibold" :class="{'text-secondary': route().current('index')}">
                Dashboard
            </div>
        </a>

        <!-- <a href="#" @click.prevent class="inline-flex space-x-[25px] items-center text-gray-20 rounded-md">
            <div class="p-3 rounded-md">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
            </div>
            <div class="text-sm font-semibold">
                Investments
            </div>
        </a>

        <a href="#" @click.prevent class="inline-flex space-x-[25px] items-center text-gray-20 rounded-md">
            <div class="p-3 rounded-md">
                <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9655 5.5C12.0369 5.17607 11.039 5 10 5C5.02944 5 1 9.02944 1 14C1 18.9706 5.02944 23 10 23C14.9706 23 19 18.9706 19 14C19 12.7586 18.7487 11.5759 18.2941 10.5M10.7593 9.05728C10.5117 9.01956 10.2581 9 10 9C7.23858 9 5 11.2386 5 14C5 16.7614 7.23858 19 10 19C12.7614 19 15 16.7614 15 14C15 13.7028 14.9741 13.4116 14.9243 13.1286M17 7H20L23 4L20 4V1L17 4V7ZM17 7L10 14M11 14C11 13.4477 10.5523 13 10 13C9.44771 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14Z" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <div class="text-sm font-semibold">
                Opportunities
            </div>
        </a>

        <a href="#" @click.prevent class="inline-flex space-x-[25px] items-center text-gray-20 rounded-md">
            <div class="p-3 rounded-md">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path></svg>
            </div>
            <div class="text-sm font-semibold">
                Activities
            </div>
        </a>

        <a href="#" @click.prevent class="inline-flex space-x-[25px] items-center text-gray-20 rounded-md">
            <div class="p-3 rounded-md">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
            </div>
            <div class="text-sm font-semibold">
                Documents
            </div>
        </a>

        <div><span class="block my-2 w-full h-[1px] bg-gray-30"></span></div>

        <a href="#" @click.prevent class="inline-flex space-x-[25px] items-center text-gray-20 rounded-md">
            <div class="p-3 rounded-md">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
            </div>
            <div class="text-sm font-semibold">
                Settings
            </div>
        </a>

        <a href="#" @click.prevent class="inline-flex space-x-[25px] items-center text-gray-20 rounded-md">
            <div class="p-3 rounded-md">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"></path></svg>
            </div>
            <div class="text-sm font-semibold">
                Support
            </div>
        </a>

        <a href="#" @click.prevent class="inline-flex space-x-[25px] items-center text-gray-20 rounded-md">
            <div class="p-3 rounded-md">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path></svg>
            </div>
            <div class="text-sm font-semibold">
                Privacy
            </div>
        </a>

        <a href="#" @click.prevent class="inline-flex space-x-[25px] items-center text-gray-20 rounded-md">
            <div class="p-3 rounded-md">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"></path></svg>
            </div>
            <div class="text-sm font-semibold">
                Disclosures
            </div>
        </a> -->
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
